import axios from "axios";

export const getProviders = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/providers", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getProvider = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/providers/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createProvider = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/providers`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createProviderUser = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/providers/${data?.provider}/create-user`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getProviderUsers = async ({ data }: any) => {	
	console.log("getProviderUsers", data.id);
	try {
		// Send as an object, not just the string
		const res: any = await axios.post(`/users/provider-users`, { id: data.id });
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateProvider = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/providers/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteProvider = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/providers/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resyncProvider = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/providers/${data?.id}/resync`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const restoreProvider = async ({ id }: { id: string }) => {
	try {
		const res: any = await axios.post(`/providers/${id}/restore`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
